<template>
  <!--  width="20" height="17" -->
  <mask id='path-1-inside-1_871_12' fill='white'>
    <rect width='20' height='17' rx='1' />
  </mask>
  <rect width='20' height='17' rx='1' stroke='#069EE0' stroke-width='3' mask='url(#path-1-inside-1_871_12)' />
  <path d='M14 9L8 12L8 6L14 9Z' fill='#069EE0' />
</template>
